import { lang } from './lang.js';
import { beads } from './beads.js';
import { modes } from './modes.js';
import { menu } from './menu.js';
import { palette } from './palette.js';
import { beadCloud } from './core/azure.js';

export const settings = {};

settings.beadDisplayHeight = 50;

settings.initialize = () => {
    settings.theme = settings.themes[0];
};

settings.update = () => {
    if (!currentUserId) return;

    const params = {
        id: currentUserId,
        recordObj: settings.preferences,
        container: 'users'
    };

    const response = beadCloud({
        fn: 'updateItemInCloud',
        params
    });

    if (typeof response.error === 'string') {
        const msg = lang.get('error saving settings', 'Error saving settings');
        menu.showInfoBox({msg, warning: true});
    }
};

settings.newProject = config => {
    if (!b3.store.state.hasBooted) b3.store.mySet('hasBooted', true);

    settings.showLetterCodes = false;
    settings.showInactiveBeads = true;
    settings.renderColorOnly = false;
    settings.guideSpacing = {x: 5, y: 5};
    settings.guidesColor = '#00FFFF';
    settings.beadDisplayHeight = config.beadDisplayHeight;
    settings.setTitle(config.title);
    settings.description = config.description;
    settings.instructions = config.instructions;
    settings.credits = config.credits;
    settings.tags = config.tags;
    settings.rows = config.rows;
    settings.columns = config.columns;
    settings.ignoreLastRow = config.ignoreLastRow;
    settings.pattern = config.pattern;
    settings.library = config.library;
    settings.diameter = config.diameter;
    settings.width = config.width;

    b3.store.mySet('plasticMode', settings.library.shape === 'plastic');
    b3.store.mySet('libraryShape', settings.library.shape);
    b3.store.mySet('pattern', settings.pattern);
};

settings.setTitle = title => {
    settings.title = title;
    document.title = title + ' | Beadographer';
};

settings.toggleLetterCodes = () => {
    settings.showLetterCodes = !settings.showLetterCodes;
    beads.refreshCanvas();
};

settings.toggleBeadSoup = () => {
    if (palette.beadSoup.length) {
        b3.store.mySet('beadSoupActive', !b3.store.state.beadSoupActive)
        if (b3.store.state.beadSoupActive) {
            palette.deselectAll();
        } else {
            palette.select(b3.store.state.swatches[0]);
        }
        modes.start('draw');
    }
};

settings.toggleInactiveBeads = () => {
    settings.showInactiveBeads = !settings.showInactiveBeads;
    beads.refreshCanvas();
};

settings.themes = [
    {
        name: 'Auto',
        description: 'auto theme option',
        displayName: lang.get('auto theme option', 'Auto'),
        toolbarColor: 0x4f9dbe,
        backgroundColor: 0xc9c9c9,
        sideColor: 0xf0f0f0,
        cornersTexture: 'round_corners',
        inactiveBead: 0xe1e1e1,
        textColor: '#000',
        secondTextColor: '#333',
        highlightColor: 0xffffff
    },
    {
        name: 'Light',
        description: 'light theme option',
        displayName: lang.get('light theme option', 'Light'),
        toolbarColor: 0x4f9dbe,
        backgroundColor: 0xffffff,
        sideColor: 0xf0f0f0,
        cornersTexture: 'round_corners_white',
        inactiveBead: 0xf0f0f0,
        textColor: '#000',
        secondTextColor: '#333',
        highlightColor: 0xffffff
    },
    {
        name: 'Dark',
        description: 'dark theme option',
        displayName: lang.get('dark theme option', 'Dark'),
        toolbarColor: 0x202020,
        backgroundColor: 0x454545,
        sideColor: 0x606060,
        cornersTexture: 'round_corners_dark',
        inactiveBead: 0x575757,
        textColor: '#eee',
        secondTextColor: '#000',
        highlightColor: 0x999999
    },
];

settings.setTheme = newTheme => {
    settings.theme = settings.themes.find(element => element.name === newTheme) || settings.themes[0];
    if (game.cameras?.main?.setBackgroundColor) {
        game.cameras.main.setBackgroundColor(settings.theme.backgroundColor);
    }
    b3.store.state.swatches.forEach(s => s.render());
    settings.preferences.theme = settings.theme.name;
    settings.update();
    beads.refreshCanvas();
};

settings.setUnits = str => {
    settings.preferences.units = str;
    settings.update();
};
